<div class="bottom-cta {{color}}">
    <div class="container">
        <div class="bottom-cta-left">
            <div class="bottom-cta-tit">¿Listo para la aventura?</div>
            <div class="bottom-cta-sub">Reserva ahora</div>
        </div>
        <div class="bottom-cta-right">
            <a class="btn btn-primary" (click)="accederReservar()" title="">Reserva ahora</a>
            <a class="btn btn-secondary" [routerLink]="pathFaqs" [queryParams]="{faq: queryParamsFaq}" title="">Preguntas
                frecuentes</a>
        </div>
    </div>
</div>
<neo-proximamente-dlg [tituloDialog]="'proximamente_dlg_tit' | transloco"
    [descripcionDialog]="'proximamente_dlg_txt' | transloco">
</neo-proximamente-dlg>